import { DroneAlertLevelEnum } from '@/types/data/data.types';

import { ClassificationEnum } from '../sensor/classification.types';

export const DRONE_STATS_NO_PLATFORM_CODE = '__drone_stats_no_platform__';
export const DRONE_STATS_NO_ZONE_CODE = '__drone_stats_no_zone__';

export type PlatformDroneCountType = { platform: string; platformName: string; count: number };

export type ZoneDroneCountType = { zoneName: string; count: number };

export type ClassificationDroneCountType = {
  classification: ClassificationEnum;
  count: number;
  countByPlatform: PlatformDroneCountType[];
};

export type LevelDroneCountType = {
  level: DroneAlertLevelEnum;
  count: number;
};

export type AltitudeRangeDroneCountType = {
  from: number;
  to: number | null;
  count: number;
};

export type IdDroneCountType = {
  id: string;
  count: number;
  countByClassification: ClassificationDroneCountType[];
};

export enum ChronoUnits {
  YEARS = 'YEARS',
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS',
  DAYS = 'DAYS',
  HALF_DAYS = 'HALF_DAYS',
  HOURS = 'HOURS',
}

export type DateRangeDroneCountType = {
  dateTime: string;
  unit: ChronoUnits;
  count: number;
  countByPlatform: PlatformDroneCountType[];
  countByLevel: LevelDroneCountType[];
  countByZone: ZoneDroneCountType[];
};

export type DroneStatistics = {
  droneAlertsCountByLevel: LevelDroneCountType[];
  droneAlertsCountByDateRange: DateRangeDroneCountType[];
  topDronesCountById: IdDroneCountType[];
  dronesCountByAltitudeRange: AltitudeRangeDroneCountType[];
  dronesCountByClassification: ClassificationDroneCountType[];
  dronesCountByPlatform: PlatformDroneCountType[];
  dronesCountByZone: ZoneDroneCountType[];
  dronesWithFlightPlansCount: number;
  dronesAlertsCount: number;
  dronesCount: number;
};
